import React from "react";
import { Container } from "@material-ui/core";
import { NavLink } from "react-router-dom";

// ─── deploymentType: "mdc" | "mobile" | "cloud" ──────────────────────────────
// mdc    = Regional Micro Data Center
// mobile = PlayStore / AppStore
// cloud  = Private Cloud / Corporate Data Center

const groups = [
  {
    groupTitle: "eMDC=Sovereign Core Stack",
    groupSubtitle: "Enabling Ecosystem Intelligence",
    groupAccent: "#9333ea",
    groupIcon: "🌐",
    deploymentType: "mdc",
    products: [
      {
        title: "Ecosystem Orchestrator",
        label: "Orchestrator Framework",
        icon: "🌐",
        gradient: "linear-gradient(145deg, #065f46, #34d399)",
        shadow: "rgba(6,95,70,0.4)",
        path: "/ABN",
      },
      {
        title: "SDH",
        label: "Edge Infrastructure",
        icon: "🏪",
        gradient: "linear-gradient(145deg, #581c87, #c084fc)",
        shadow: "rgba(126,34,206,0.4)",
        path: "/SDH",
      },
      {
        title: "Field Network",
        label: "For Micro-Entrepreneurs",
        icon: "🚜",
        gradient: "linear-gradient(145deg, #92400e, #f59e0b)",
        shadow: "rgba(146,64,14,0.4)",
        path: "/edge-ai-network",
      },
    ],
  },
  {
    groupTitle: "Field Execution Layer",
    groupSubtitle: "Mobile Applications for rural staff and entrepreneurs",
    groupAccent: "#16a34a",
    groupIcon: "📱",
    deploymentType: "mobile",
    products: [
      {
        title: "AgriMiner",
        label: "App",
        icon: "🌾",
        gradient: "linear-gradient(145deg, #15803d, #22c55e)",
        shadow: "rgba(22,163,74,0.4)",
        path: "/agriminer-app",
      },
      {
        title: "AAMC",
        label: "App",
        icon: "📊",
        gradient: "linear-gradient(145deg, #0369a1, #38bdf8)",
        shadow: "rgba(3,105,161,0.4)",
        path: "/aamc-app",
      },
      {
        title: "CBN",
        label: "App",
        icon: "🤝",
        gradient: "linear-gradient(145deg, #6d28d9, #a78bfa)",
        shadow: "rgba(109,40,217,0.4)",
        path: "/cbn-app",
      },
    ],
  },
  {
    groupTitle: "Central Orchestration Layer",
    groupSubtitle: "Manages ecosystem networks, workflows, exchanges, and connected infrastructure.",
    groupAccent: "#d97706",
    groupIcon: "🌿",
    deploymentType: "cloud",
    products: [
      {
        title: "AgriCloud",
        label: "Cloud Stack",
        icon: "☁️",
        gradient: "linear-gradient(145deg, #78350f, #d97706)",
        shadow: "rgba(180,83,9,0.35)",
        path: "/comingsoon",
      },
      {
        title: "Sovereign Infrastructure Console",
        label: "Provisions ecosystem operators",
        icon: "🏪",
        gradient: "linear-gradient(145deg, #7f1d1d, #ef4444)",
        shadow: "rgba(190,18,60,0.35)",
        path: "/comingsoon",
      },
      {
        title: "Device.Network",
        label: "Orchestration",
        icon: "📡",
        gradient: "linear-gradient(145deg, #164e63, #06b6d4)",
        shadow: "rgba(14,116,144,0.35)",
        path: "/ComingSoon",
      },
    ],
  },
  {
    groupTitle: "ANOS Core",
    groupSubtitle: "Agribusiness Network Operating System — core intelligence layer",
    groupAccent: "#1d4ed8",
    groupIcon: "⚡",
    deploymentType: "cloud",
    products: [
      {
        title: "ANOS Engine",
        label: "Network OS Core",
        icon: "⚡",
        gradient: "linear-gradient(145deg, #1e3a8a, #3b82f6)",
        shadow: "rgba(30,58,138,0.4)",
        path: "/core-stack",
      },
      {
        title: "Policy Manager",
        label: "Governance & Rules",
        icon: "📋",
        gradient: "linear-gradient(145deg, #1e40af, #60a5fa)",
        shadow: "rgba(30,64,175,0.35)",
        path: "/comingsoon",
      },
      {
        title: "Network Intelligence",
        label: "Analytics & AI Ops",
        icon: "🧠",
        gradient: "linear-gradient(145deg, #312e81, #818cf8)",
        shadow: "rgba(49,46,129,0.4)",
        path: "/comingsoon",
      },
    ],
  },
];

// ─── Deployment config lookup ─────────────────────────────────────────────────
const deploymentConfig = {
  mdc: {
    // dark-bg (used on dark sections)
    color: "#9333ea",
    glow: "rgba(147,51,234,0.6)",
    borderColor: "rgba(147,51,234,0.35)",
    bgCard: "rgba(147,51,234,0.07)",
    bgHover: "rgba(147,51,234,0.13)",
    pillBg: "rgba(147,51,234,0.18)",
    pillBorder: "rgba(147,51,234,0.4)",
    pillColor: "#c084fc",
    groupBg: "rgba(255,255,255,0.10)",
    groupBorder: "rgba(147,51,234,0.3)",
    groupShadow: "0 4px 24px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.10)",
    badgeLabel: "Regional Micro Data Center",
    badgeIcon: "🏢",
    // light-bg overrides
    lightGroupBg: "#faf5ff",
    lightGroupBorder: "#e9d5ff",
    lightGroupShadow: "0 2px 16px rgba(147,51,234,0.08)",
    lightBgCard: "rgba(147,51,234,0.04)",
    lightBgHover: "rgba(147,51,234,0.09)",
    lightBorderColor: "rgba(147,51,234,0.2)",
    lightTitleColor: "#1e293b",
    lightSubColor: "#64748b",
    lightExplore: "#9333ea",
  },
  mobile: {
    color: "#16a34a",
    glow: "rgba(22,163,74,0.6)",
    borderColor: "rgba(22,163,74,0.3)",
    bgCard: "rgba(22,163,74,0.06)",
    bgHover: "rgba(22,163,74,0.12)",
    pillBg: "rgba(22,163,74,0.18)",
    pillBorder: "rgba(22,163,74,0.4)",
    pillColor: "#4ade80",
    groupBg: "rgba(255,255,255,0.10)",
    groupBorder: "rgba(22,163,74,0.28)",
    groupShadow: "0 4px 24px rgba(0,0,0,0.18), inset 0 1px 0 rgba(22,163,74,0.08)",
    badgeLabel: "PlayStore / AppStore",
    badgeIcon: "📱",
    lightGroupBg: "#f0fdf4",
    lightGroupBorder: "#bbf7d0",
    lightGroupShadow: "0 2px 16px rgba(22,163,74,0.08)",
    lightBgCard: "rgba(22,163,74,0.04)",
    lightBgHover: "rgba(22,163,74,0.09)",
    lightBorderColor: "rgba(22,163,74,0.2)",
    lightTitleColor: "#1e293b",
    lightSubColor: "#64748b",
    lightExplore: "#16a34a",
  },
  cloud: {
    color: "#2563eb",
    glow: "rgba(37,99,235,0.6)",
    borderColor: "rgba(37,99,235,0.3)",
    bgCard: "rgba(37,99,235,0.06)",
    bgHover: "rgba(37,99,235,0.12)",
    pillBg: "rgba(37,99,235,0.18)",
    pillBorder: "rgba(37,99,235,0.4)",
    pillColor: "#93c5fd",
    groupBg: "rgba(37,99,235,0.08)",
    groupBorder: "rgba(37,99,235,0.28)",
    groupShadow: "0 4px 24px rgba(0,0,0,0.28), inset 0 1px 0 rgba(37,99,235,0.1)",
    badgeLabel: "Private Cloud / Corporate DC",
    badgeIcon: "☁️",
    lightGroupBg: "#eff6ff",
    lightGroupBorder: "#bfdbfe",
    lightGroupShadow: "0 2px 16px rgba(37,99,235,0.08)",
    lightBgCard: "rgba(37,99,235,0.04)",
    lightBgHover: "rgba(37,99,235,0.09)",
    lightBorderColor: "rgba(37,99,235,0.2)",
    lightTitleColor: "#1e293b",
    lightSubColor: "#64748b",
    lightExplore: "#2563eb",
  },
};

// ─── AppCard ──────────────────────────────────────────────────────────────────
const AppCard = ({ title, label, icon, gradient, shadow, path, lightBg }) => (
  <NavLink to={path} style={{ textDecoration: "none" }}>
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "6px", cursor: "pointer", width: "64px" }}
      onMouseEnter={(e) => {
        const box = e.currentTarget.querySelector(".app-icon-box");
        box.style.transform = "scale(1.12) translateY(-3px)";
        box.style.boxShadow = `0 14px 28px ${shadow}`;
      }}
      onMouseLeave={(e) => {
        const box = e.currentTarget.querySelector(".app-icon-box");
        box.style.transform = "scale(1) translateY(0)";
        box.style.boxShadow = `0 4px 12px ${shadow}`;
      }}
    >
      <div
        className="app-icon-box"
        style={{
          width: "52px",
          height: "52px",
          borderRadius: "14px",
          background: gradient,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "22px",
          boxShadow: `0 4px 12px ${shadow}`,
          transition: "transform 0.26s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.26s ease",
          border: "1px solid rgba(255,255,255,0.2)",
        }}
      >
        {icon}
      </div>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: "0.65rem", fontWeight: 700, color: lightBg ? "#1e293b" : "#fff", lineHeight: 1.2, textShadow: lightBg ? "none" : "0 1px 3px rgba(0,0,0,0.6)" }}>
          {title}
        </div>
        <div style={{ fontSize: "0.55rem", color: lightBg ? "#94a3b8" : "rgba(255,255,255,0.5)", marginTop: "2px", fontWeight: 500 }}>
          {label}
        </div>
      </div>
    </div>
  </NavLink>
);

// ─── GroupSection ─────────────────────────────────────────────────────────────
const GroupSection = ({ groupTitle, groupSubtitle, groupAccent, groupIcon, deploymentType, products, lightBg }) => {
  const cfg = deploymentConfig[deploymentType];
  const gb   = lightBg ? cfg.lightGroupBg     : cfg.groupBg;
  const gbrd = lightBg ? cfg.lightGroupBorder  : cfg.groupBorder;
  const gsh  = lightBg ? cfg.lightGroupShadow  : cfg.groupShadow;
  const bc   = lightBg ? cfg.lightBorderColor  : cfg.borderColor;
  const bcard  = lightBg ? cfg.lightBgCard     : cfg.bgCard;
  const bhover = lightBg ? cfg.lightBgHover    : cfg.bgHover;
  const titleC = lightBg ? cfg.lightTitleColor : "#fff";
  const subC   = lightBg ? cfg.lightSubColor   : "rgba(255,255,255,0.42)";
  const exploreC = lightBg ? cfg.lightExplore  : cfg.pillColor;
  const arrowBg  = lightBg ? "rgba(0,0,0,0.04)"  : "rgba(255,255,255,0.07)";
  const arrowBrd = lightBg ? "rgba(0,0,0,0.10)"  : "rgba(255,255,255,0.14)";
  const arrowC   = lightBg ? "#94a3b8"            : "rgba(255,255,255,0.45)";
  return (
    <div
      style={{
        background: gb,
        backdropFilter: lightBg ? "none" : "blur(20px)",
        WebkitBackdropFilter: lightBg ? "none" : "blur(20px)",
        borderRadius: "18px",
        padding: "18px 18px 20px",
        border: `1px solid ${gbrd}`,
        boxShadow: gsh,
        position: "relative",
        overflow: "hidden",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Accent glow */}
      <div
        style={{
          position: "absolute", top: "-30px", left: "-15px",
          width: "110px", height: "110px", borderRadius: "50%",
          background: groupAccent, opacity: lightBg ? 0.07 : 0.13,
          filter: "blur(32px)", pointerEvents: "none",
        }}
      />

      {/* Header */}
      <div
        style={{
          display: "flex", alignItems: "center", gap: "10px",
          marginBottom: "14px", paddingBottom: "12px",
          borderBottom: `1px solid ${bc}`,
          flexShrink: 0,
        }}
      >
        <div
          style={{
            width: "30px", height: "30px", borderRadius: "9px",
            background: `${groupAccent}22`, border: `1px solid ${groupAccent}44`,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: "14px", flexShrink: 0,
          }}
        >
          {groupIcon}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: "0.82rem", fontWeight: 800, color: titleC, letterSpacing: "-0.1px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {groupTitle}
          </div>
          <div style={{ fontSize: "0.6rem", color: subC, marginTop: "2px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {groupSubtitle}
          </div>
        </div>

        {/* Deployment badge pill */}
        <div
          style={{
            flexShrink: 0, padding: "3px 8px", borderRadius: "20px",
            fontSize: "0.5rem", fontWeight: 700, letterSpacing: "0.3px", textTransform: "uppercase",
            background: cfg.pillBg, border: `1px solid ${cfg.pillBorder}`, color: cfg.pillColor,
            whiteSpace: "nowrap",
          }}
        >
          {cfg.badgeIcon} {cfg.badgeLabel}
        </div>
      </div>

      {/* Product rows */}
      <div style={{ display: "flex", flexDirection: "column", gap: "8px", flexGrow: 1, justifyContent: "space-between" }}>
        {products.map((product, i) => (
          <div
            key={i}
            style={{
              display: "flex", alignItems: "center", gap: "14px",
              padding: "10px 12px", borderRadius: "12px",
              background: bcard,
              border: `1px solid ${bc}`,
              transition: "background 0.2s ease, border-color 0.2s ease",
              flexGrow: 1,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = bhover;
              e.currentTarget.style.borderColor = cfg.color + "55";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = bcard;
              e.currentTarget.style.borderColor = bc;
            }}
          >
            <AppCard {...product} lightBg={lightBg} />

            <NavLink to={product.path} style={{ textDecoration: "none", flex: 1 }}>
              <div style={{ fontSize: "0.72rem", fontWeight: 600, color: lightBg ? "#1e293b" : "rgba(255,255,255,0.9)", lineHeight: 1.3, marginBottom: "3px" }}>
                {product.title}
              </div>
              <div style={{ fontSize: "0.6rem", color: lightBg ? "#94a3b8" : "rgba(255,255,255,0.42)", lineHeight: 1.3, marginBottom: "2px" }}>
                {product.label}
              </div>
              <div style={{ fontSize: "0.55rem", color: exploreC, lineHeight: 1.3 }}>
                Tap to explore →
              </div>
            </NavLink>

            <div
              style={{
                width: "24px", height: "24px", borderRadius: "50%",
                background: arrowBg, border: `1px solid ${arrowBrd}`,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: "0.65rem", color: arrowC, flexShrink: 0,
              }}
            >
              →
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// ─── Package data ─────────────────────────────────────────────────────────────
const packages = [
  {
    id: "enterprise",
    badge: "Large Enterprise",
    badgeColor: "#7c3aed",
    badgeBg: "rgba(124,58,237,0.08)",
    badgeBorder: "rgba(124,58,237,0.3)",
    icon: "🏛️",
    title: "Enterprise Ecosystem Suite",
    subtitle: "For large agribusinesses operating multi-tier, multi-geography distribution, procurement, and sustainability networks at scale.",
    accentColor: "#7c3aed",
    accentLight: "#faf5ff",
    accentBorder: "#c4b5fd",
    components: [
      { icon: "🌐", name: "eMDC=Sovereign Core Stack", desc: "Full deployment in dedicated Regional Micro Data Centers with sovereign data control" },
      { icon: "⚡", name: "ANOS Core", desc: "Enterprise-grade network operating system with policy management and AI intelligence" },
      { icon: "🌿", name: "Central Orchestration Layer", desc: "Private cloud / corporate data center deployment for complete orchestration control" },
      { icon: "📱", name: "Field Execution Layer", desc: "Full suite of mobile apps deployed across PlayStore and AppStore for field operations" },
    ],
    capabilities: [
      "Multi-tier participant orchestration",
      "Sovereign data infrastructure",
      "Enterprise governance & compliance",
      "AI-ready operational intelligence",
      "Multi-geography network operations",
      "Custom workflow configuration",
      "ESG & traceability at scale",
      "Dedicated infrastructure provisioning",
    ],
    cta: "Talk to Enterprise Team",
    ctaPath: "/si-registration",
  },
  {
    id: "federation",
    badge: "Federation Administrators",
    badgeColor: "#0891b2",
    badgeBg: "rgba(8,145,178,0.08)",
    badgeBorder: "rgba(8,145,178,0.3)",
    icon: "🔗",
    title: "Federation Administration Suite",
    subtitle: "For administrators managing federated networks of agribusiness operators, cooperatives, FPOs, and regional ecosystem nodes.",
    accentColor: "#0891b2",
    accentLight: "#f0f9ff",
    accentBorder: "#7dd3fc",
    components: [
      { icon: "⚡", name: "ANOS Core", desc: "Central policy engine governing federated network rules, participation, and compliance across nodes", optional: true },
      { icon: "🌿", name: "Central Orchestration Layer", desc: "Federated orchestration deployed in private cloud to manage cross-network workflows and exchanges", optional: false },
      { icon: "🌐", name: "eMDC=Sovereign Core Stack", desc: "Regional Micro Data Center nodes for sovereign data at the federation edge", optional: false },
    ],
    capabilities: [
      "Federated participant governance",
      "Cross-network workflow coordination",
      "Node-level sovereignty management",
      "Federation-wide compliance policies",
      "Aggregated intelligence dashboard",
      "Multi-operator provisioning",
      "Federated traceability systems",
      "Ecosystem monetization administration",
    ],
    cta: "Enquire About Federation Access",
    ctaPath: "/si-registration",
  },
  {
    id: "mid-market",
    badge: "Ecosystem Network Operators",
    badgeColor: "#16a34a",
    badgeBg: "rgba(22,163,74,0.08)",
    badgeBorder: "rgba(22,163,74,0.3)",
    icon: "🌾",
    title: "Agribusiness Network Operator Suite",
    subtitle: "For mid-size agribusinesses and ecosystem network operators building, running, and monetizing their own agribusiness network.",
    accentColor: "#16a34a",
    accentLight: "#f0fdf4",
    accentBorder: "#86efac",
    components: [
      { icon: "🌍", name: "Ecosystem Network Framework", desc: "The overarching platform that governs participants, workflows, and ecosystem operations", optional: false },
      { icon: "🌐", name: "eMDC=Sovereign Core Stack", desc: "Regional Micro Data Center deployment for sovereign data and edge intelligence", optional: false },
      { icon: "🌿", name: "Central Orchestration Layer", desc: "Private cloud deployment to orchestrate participants, workflows, and network operations", optional: true },
      { icon: "📱", name: "Field Execution Layer", desc: "Mobile apps for field participants — farmers, agents, field operators, eco-entrepreneurs", optional: false },
    ],
    capabilities: [
      "Participant onboarding & governance",
      "Procurement & logistics workflows",
      "Marketplace & commercial coordination",
      "ESG & sustainability participation",
      "Network monetization models",
      "Operational visibility dashboards",
      "Traceability & compliance systems",
      "Scalable network growth infrastructure",
    ],
    cta: "Activate Your Network",
    ctaPath: "/si-registration",
  },
];

// ─── PackageSection component ─────────────────────────────────────────────────
const PackageSection = ({ badge, badgeColor, badgeBg, badgeBorder, icon, title, subtitle, accentColor, accentLight, accentBorder, components, capabilities, cta, ctaPath }) => (
  <div
    style={{
      background: "#ffffff",
      borderRadius: "20px",
      padding: "28px 24px 24px",
      border: `1px solid ${accentBorder}`,
      boxShadow: `0 2px 20px rgba(0,0,0,0.05)`,
      position: "relative",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      height: "100%",
    }}
  >
    {/* Top accent bar */}
    <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: "3px", background: `linear-gradient(90deg, ${accentColor}, ${accentColor}66)` }} />

    {/* Badge */}
    <div style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: badgeBg, border: `1px solid ${badgeBorder}`, borderRadius: "20px", padding: "3px 12px", marginBottom: "14px", alignSelf: "flex-start" }}>
      <span style={{ fontSize: "0.72rem" }}>{icon}</span>
      <span style={{ fontSize: "0.63rem", fontWeight: 700, color: badgeColor, letterSpacing: "0.6px", textTransform: "uppercase" }}>{badge}</span>
    </div>

    <h3 style={{ fontSize: "1.05rem", fontWeight: 800, color: "#1e293b", marginBottom: "8px", lineHeight: 1.3 }}>{title}</h3>
    <p style={{ fontSize: "0.8rem", color: "#64748b", lineHeight: 1.7, marginBottom: "20px" }}>{subtitle}</p>

    {/* Included components */}
    <div style={{ marginBottom: "18px" }}>
      <div style={{ fontSize: "0.62rem", fontWeight: 700, letterSpacing: "0.8px", textTransform: "uppercase", color: accentColor, marginBottom: "10px" }}>
        Included Infrastructure
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "7px" }}>
        {components.map((c, i) => (
          <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: "10px", background: c.optional ? "#ffffff" : accentLight, border: `1px solid ${c.optional ? "#e2e8f0" : accentBorder}`, borderRadius: "10px", padding: "10px 12px", position: "relative" }}>
            <span style={{ fontSize: "1rem", flexShrink: 0 }}>{c.icon}</span>
            <div style={{ flex: 1 }}>
              <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "2px", flexWrap: "wrap" }}>
                <div style={{ fontSize: "0.74rem", fontWeight: 700, color: "#1e293b" }}>{c.name}</div>
                {c.optional && (
                  <span style={{ fontSize: "0.5rem", fontWeight: 700, color: "#94a3b8", background: "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: "10px", padding: "1px 6px", textTransform: "uppercase", letterSpacing: "0.5px", flexShrink: 0 }}>Optional</span>
                )}
              </div>
              <div style={{ fontSize: "0.68rem", color: "#64748b", lineHeight: 1.5 }}>{c.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </div>

    {/* Capabilities */}
    <div style={{ marginBottom: "22px", flexGrow: 1 }}>
      <div style={{ fontSize: "0.62rem", fontWeight: 700, letterSpacing: "0.8px", textTransform: "uppercase", color: accentColor, marginBottom: "10px" }}>
        Key Capabilities
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "5px 10px" }}>
        {capabilities.map((cap, i) => (
          <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: "5px", fontSize: "0.72rem", color: "#475569", lineHeight: 1.4 }}>
            <span style={{ color: accentColor, fontWeight: 700, flexShrink: 0, marginTop: "1px" }}>✓</span>
            <span>{cap}</span>
          </div>
        ))}
      </div>
    </div>

    {/* CTA button */}
    <NavLink to={ctaPath} style={{ textDecoration: "none" }}>
      <div
        style={{
          background: accentColor,
          borderRadius: "10px",
          padding: "12px 16px",
          textAlign: "center",
          fontSize: "0.78rem",
          fontWeight: 700,
          color: "#ffffff",
          cursor: "pointer",
          transition: "opacity 0.2s",
          letterSpacing: "0.2px",
        }}
        onMouseEnter={(e) => { e.currentTarget.style.opacity = "0.88"; }}
        onMouseLeave={(e) => { e.currentTarget.style.opacity = "1"; }}
      >
        {cta} →
      </div>
    </NavLink>
  </div>
);

// ─── Legend ───────────────────────────────────────────────────────────────────
const legends = [
  { color: "#9333ea", glow: "rgba(147,51,234,0.7)", label: "Regional Micro Data Center" },
  { color: "#16a34a", glow: "rgba(22,163,74,0.7)",  label: "PlayStore / AppStore" },
  { color: "#2563eb", glow: "rgba(37,99,235,0.7)",  label: "Private Cloud / Corporate DC" },
];

// ─── Main Component ───────────────────────────────────────────────────────────
const OurProductAndServices = () => {
  return (
    <div className="explore-network-container">

      {/* ══════════════════════════════════════════════════════════════════════
          SECTION 1 — BANNER  (light grey + light green + light blue)
      ══════════════════════════════════════════════════════════════════════ */}
      <div
        className="stack-banner mx-auto"
        style={{
          overflow: "hidden",
          marginBottom: "0",
          backgroundPositionY: "center",
          backgroundSize: "cover",
          minHeight: "460px",
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
      >
        {/* Base: light grey */}
        <div style={{ position: "absolute", inset: 0, background: "#f1f5f9", zIndex: 1 }} />
        {/* Light green bloom — top left */}
        <div style={{ position: "absolute", top: "-60px", left: "-60px", width: "520px", height: "520px", borderRadius: "50%", background: "radial-gradient(circle, rgba(187,247,208,0.70) 0%, rgba(134,239,172,0.30) 45%, transparent 72%)", zIndex: 2, pointerEvents: "none" }} />
        {/* Light blue bloom — bottom right */}
        <div style={{ position: "absolute", bottom: "-80px", right: "-60px", width: "480px", height: "480px", borderRadius: "50%", background: "radial-gradient(circle, rgba(191,219,254,0.65) 0%, rgba(147,197,253,0.28) 45%, transparent 72%)", zIndex: 2, pointerEvents: "none" }} />
        {/* Soft grey centre wash — ties the blobs together */}
        <div style={{ position: "absolute", inset: 0, background: "radial-gradient(ellipse 75% 60% at 50% 50%, rgba(226,232,240,0.45) 0%, transparent 70%)", zIndex: 3, pointerEvents: "none" }} />

        {/* Content */}
        <div style={{ position: "relative", zIndex: 4, width: "100%", padding: "64px 16px 60px" }}>
          <div style={{ textAlign: "center", maxWidth: "820px", margin: "0 auto" }}>

            {/* Eyebrow pill */}
            <div style={{ display: "inline-flex", alignItems: "center", gap: "7px", background: "rgba(255,255,255,0.75)", border: "1px solid rgba(148,163,184,0.45)", borderRadius: "20px", padding: "5px 18px", marginBottom: "24px", boxShadow: "0 1px 6px rgba(0,0,0,0.06)" }}>
              <div style={{ width: "6px", height: "6px", borderRadius: "50%", background: "#16a34a", boxShadow: "0 0 6px rgba(22,163,74,0.5)" }} />
              <span style={{ fontSize: "0.65rem", fontWeight: 700, color: "#1e293b", letterSpacing: "1.3px", textTransform: "uppercase" }}>
                Deployment Scenariosn of Sovereign Ecosystem Infrastructure
              </span>
            </div>

            {/* Main headline */}
            <h1 style={{ fontSize: "clamp(1.9rem, 5vw, 3.2rem)", fontWeight: 900, color: "#0f172a", lineHeight: 1.15, marginBottom: "18px", letterSpacing: "-0.5px" }}>
              Infrastructure to Orchestrate<br />
              <span style={{ background: "linear-gradient(90deg, #15803d, #0369a1)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text" }}>
                Your Agribusiness Ecosystem
              </span>
            </h1>

            {/* Sub-headline */}
            <p style={{ fontSize: "clamp(0.88rem, 1.8vw, 1.05rem)", color: "#475569", lineHeight: 1.8, maxWidth: "600px", margin: "0 auto 36px" }}>
              A sovereign, multi-layer infrastructure platform purpose-built to activate, operate, and scale agribusiness networks — from the field edge to the cloud core.
            </p>

            {/* Framework label */}
            <div style={{ fontSize: "0.65rem", fontWeight: 700, color: "#64748b", letterSpacing: "1px", textTransform: "uppercase", marginBottom: "12px" }}>
              Subsystems Packages
            </div>

            {/* ENF + 4 subsystem pills */}
            <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "10px", marginBottom: "42px" }}>
              {/* ENF — visually distinct as the overarching framework */}
              <div style={{ display: "inline-flex", alignItems: "center", gap: "8px", background: "linear-gradient(135deg, rgba(21,128,61,0.12), rgba(3,105,161,0.12))", border: "1.5px solid rgba(21,128,61,0.35)", borderRadius: "12px", padding: "8px 18px", boxShadow: "0 1px 6px rgba(0,0,0,0.06)" }}>
                <span style={{ fontSize: "1rem" }}>🌍</span>
                <div>
                  {/* <div style={{ fontSize: "0.6rem", fontWeight: 700, color: "#15803d", letterSpacing: "0.8px", textTransform: "uppercase" }}>Platform</div> */}
                  <div style={{ fontSize: "0.78rem", fontWeight: 800, color: "#0f172a" }}>Ecosystem Network Framework</div>
                </div>
              </div>

              {/* 4 subsystem pills */}
              {[
                { icon: "🌐", label: "eMDC = Sovereign Core Stack",   color: "#7c3aed", bg: "rgba(147,51,234,0.08)",  border: "rgba(147,51,234,0.25)" },
                { icon: "🧠", label: "Ecosystem Intelligence Layer(EIL)",   color: "#7c3aed", bg: "rgba(147,51,234,0.08)",  border: "rgba(147,51,234,0.25)" },
                { icon: "📱", label: "Field Execution Layer",          color: "#15803d", bg: "rgba(22,163,74,0.08)",   border: "rgba(22,163,74,0.25)"  },
                { icon: "🌿", label: "Central Orchestration Layer",    color: "#0369a1", bg: "rgba(37,99,235,0.08)",   border: "rgba(37,99,235,0.25)"  },
                { icon: "⚡", label: "ANOS Core",                      color: "#0369a1", bg: "rgba(37,99,235,0.08)",   border: "rgba(37,99,235,0.25)"  },
              ].map((item, i) => (
                <div key={i} style={{ display: "inline-flex", alignItems: "center", gap: "7px", background: item.bg, border: `1px solid ${item.border}`, borderRadius: "10px", padding: "7px 14px", boxShadow: "0 1px 4px rgba(0,0,0,0.05)" }}>
                  <span style={{ fontSize: "0.9rem" }}>{item.icon}</span>
                  <span style={{ fontSize: "0.72rem", fontWeight: 600, color: item.color }}>{item.label}</span>
                </div>
              ))}
            </div>

            {/* Scroll nudge */}
            {/* <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px" }}>
              <div style={{ width: "44px", height: "1px", background: "rgba(100,116,139,0.3)" }} />
              <span style={{ fontSize: "0.63rem", color: "#94a3b8", letterSpacing: "0.9px", textTransform: "uppercase" }}>Explore packages &amp; stack below</span>
              <div style={{ width: "44px", height: "1px", background: "rgba(100,116,139,0.3)" }} />
            </div> */}

          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════════════════════
          SECTION 2 — DEPLOYMENT PACKAGES   background: #ffffff (white)
      ══════════════════════════════════════════════════════════════════════ */}
      <div style={{ background: "#ffffff", padding: "72px 0 80px" }}>
        <Container maxWidth="lg">
          <div style={{ textAlign: "center", marginBottom: "48px" }}>
            <div style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "rgba(22,163,74,0.08)", border: "1px solid rgba(22,163,74,0.25)", borderRadius: "20px", padding: "4px 16px", marginBottom: "14px" }}>
              <div style={{ width: "5px", height: "5px", borderRadius: "50%", background: "#16a34a", boxShadow: "0 0 5px rgba(22,163,74,0.6)" }} />
              <span style={{ fontSize: "0.65rem", fontWeight: 700, color: "#16a34a", letterSpacing: "1px", textTransform: "uppercase" }}>Deployment Packages</span>
            </div>
            <h2 style={{ fontSize: "clamp(1.5rem, 3vw, 2.1rem)", fontWeight: 800, color: "#1e293b", marginBottom: "12px", lineHeight: 1.25 }}>
              The Right Infrastructure for Every Operator
            </h2>
            <p style={{ fontSize: "0.9rem", color: "#64748b", maxWidth: "560px", margin: "0 auto", lineHeight: 1.8 }}>
              GBR's infrastructure stack is packaged to match the scale, complexity, and operational model of different agribusiness operators.
            </p>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "24px", alignItems: "stretch" }}>
            {packages.map((pkg) => (
              <PackageSection key={pkg.id} {...pkg} />
            ))}
          </div>
        </Container>
      </div>

      {/* ══════════════════════════════════════════════════════════════════════
          SECTION 3 — EDGE INFRASTRUCTURE                                     
          eMDC = Sovereign Core Stack  +  Field Execution Layer               
          background: #f8fafc (off-white)
      ══════════════════════════════════════════════════════════════════════ */}
      <div style={{ background: "#f8fafc", padding: "72px 0 80px" }}>
        <Container maxWidth="lg">
          <div style={{ textAlign: "center", marginBottom: "44px" }}>
            <div style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "rgba(147,51,234,0.08)", border: "1px solid rgba(147,51,234,0.25)", borderRadius: "20px", padding: "4px 16px", marginBottom: "14px" }}>
              <div style={{ width: "5px", height: "5px", borderRadius: "50%", background: "#9333ea", boxShadow: "0 0 5px rgba(147,51,234,0.5)" }} />
              <span style={{ fontSize: "0.65rem", fontWeight: 700, color: "#9333ea", letterSpacing: "1px", textTransform: "uppercase" }}>WHAT GOES TO REGIONAL MICRO DATA CENTER & PLAY STORES -RECOMMENDED</span>
            </div>
            <h2 style={{ fontSize: "clamp(1.5rem, 3vw, 2.1rem)", fontWeight: 800, color: "#1e293b", marginBottom: "12px", lineHeight: 1.25 }}>
              Sovereign Data Centre &amp; Field Execution Apps
            </h2>
            <p style={{ fontSize: "0.88rem", color: "#64748b", maxWidth: "560px", margin: "0 auto", lineHeight: 1.8 }}>
              The two layers that operate at the edge — a Regional Micro Data Center sovereign stack and a full suite of field-facing mobile applications.
            </p>
          </div>

          {/* 2-column grid — groups[0] eMDC + groups[1] Field Execution */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: "20px", marginBottom: "20px" }}>
            {groups.slice(0, 2).map((group, i) => (
              <GroupSection key={i} {...group} lightBg={true} />
            ))}
          </div>

          {/* Legend — mdc + mobile only */}
          <div style={{ display: "flex", justifyContent: "center", gap: "28px", marginTop: "6px", flexWrap: "wrap" }}>
            {legends.slice(0, 2).map(({ color, glow, label }) => (
              <div key={label} style={{ display: "flex", alignItems: "center", gap: "7px" }}>
                <div style={{ width: "9px", height: "9px", borderRadius: "50%", background: color, boxShadow: `0 0 6px ${glow}` }} />
                <span style={{ fontSize: "0.63rem", color: "#94a3b8", fontWeight: 500 }}>{label}</span>
              </div>
            ))}
          </div>
        </Container>
      </div>

      {/* ══════════════════════════════════════════════════════════════════════
          SECTION 4 — DEPLOYMENT --> CLOUD OR CORPORATE DATACENTER                                    
          Central Orchestration Layer  +  ANOS Core                           
          background: #ffffff (white)
      ══════════════════════════════════════════════════════════════════════ */}
      <div style={{ background: "#ffffff", padding: "72px 0 80px" }}>
        <Container maxWidth="lg">
          <div style={{ textAlign: "center", marginBottom: "44px" }}>
            <div style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "rgba(37,99,235,0.08)", border: "1px solid rgba(37,99,235,0.25)", borderRadius: "20px", padding: "4px 16px", marginBottom: "14px" }}>
              <div style={{ width: "5px", height: "5px", borderRadius: "50%", background: "#2563eb", boxShadow: "0 0 5px rgba(37,99,235,0.5)" }} />
              <span style={{ fontSize: "0.65rem", fontWeight: 700, color: "#2563eb", letterSpacing: "1px", textTransform: "uppercase" }}>WHAT GOES IN CLOUD OR CORPORATE DATACENTER -RECOMMENDED </span>
            </div>
            <h2 style={{ fontSize: "clamp(1.5rem, 3vw, 2.1rem)", fontWeight: 800, color: "#1e293b", marginBottom: "12px", lineHeight: 1.25 }}>
              Central Orchestration &amp; Agentic Network OS
            </h2>
            <p style={{ fontSize: "0.88rem", color: "#64748b", maxWidth: "560px", margin: "0 auto", lineHeight: 1.8 }}>
              The two layers that operate in private cloud or corporate data centres — centralised workflow orchestration and the ANOS network operating system.
            </p>
          </div>

          {/* 2-column grid — groups[2] Central Orchestration + groups[3] ANOS Core */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: "20px", marginBottom: "20px" }}>
            {groups.slice(2, 4).map((group, i) => (
              <GroupSection key={i} {...group} lightBg={true} />
            ))}
          </div>

          {/* Legend — cloud only */}
          <div style={{ display: "flex", justifyContent: "center", gap: "28px", marginTop: "6px", flexWrap: "wrap" }}>
            {legends.slice(2, 3).map(({ color, glow, label }) => (
              <div key={label} style={{ display: "flex", alignItems: "center", gap: "7px" }}>
                <div style={{ width: "9px", height: "9px", borderRadius: "50%", background: color, boxShadow: `0 0 6px ${glow}` }} />
                <span style={{ fontSize: "0.63rem", color: "#94a3b8", fontWeight: 500 }}>{label}</span>
              </div>
            ))}
          </div>
        </Container>
      </div>

      {/* ══════════════════════════════════════════════════════════════════════
          SECTION 5 — FINAL CTA      background: #f8fafc (off-white)
      ══════════════════════════════════════════════════════════════════════ */}
      <div style={{ background: "#f8fafc", padding: "80px 0 88px" }}>
        <Container maxWidth="md">
          <div style={{ textAlign: "center", maxWidth: "720px", margin: "0 auto" }}>

            {/* Eyebrow */}
            <div style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "rgba(22,163,74,0.08)", border: "1px solid rgba(22,163,74,0.25)", borderRadius: "20px", padding: "4px 16px", marginBottom: "20px" }}>
              <div style={{ width: "5px", height: "5px", borderRadius: "50%", background: "#16a34a", boxShadow: "0 0 5px rgba(22,163,74,0.5)" }} />
              <span style={{ fontSize: "0.65rem", fontWeight: 700, color: "#16a34a", letterSpacing: "1px", textTransform: "uppercase" }}>Customized Deployment Strategy</span>
            </div>

            {/* Headline */}
            <h2 style={{ fontSize: "clamp(1.5rem, 3.5vw, 2.2rem)", fontWeight: 800, color: "#0f172a", lineHeight: 1.25, marginBottom: "14px" }}>
              Customize the Right Deployment Strategy<br />
              <span style={{ color: "#15803d" }}>for Your Agribusiness Future</span>
            </h2>

            <p style={{ fontSize: "0.92rem", color: "#475569", lineHeight: 1.8, marginBottom: "32px" }}>
              Whether you need:
            </p>

            {/* Need list — 2-column pill grid */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "10px", marginBottom: "36px", textAlign: "left" }}>
              {[
                { icon: "🤖", label: "Shared AI infrastructure" },
                { icon: "🏛️", label: "Sovereign enterprise deployment" },
                { icon: "🌍", label: "Multi-region operations" },
                { icon: "🌐", label: "Ecosystem-scale orchestration" },
                { icon: "📡", label: "Distributed edge intelligence" },
                { icon: "🔗", label: "Federated operational networks" },
              ].map((item, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", gap: "10px", background: "#ffffff", border: "1px solid #e2e8f0", borderRadius: "12px", padding: "12px 16px", boxShadow: "0 1px 4px rgba(0,0,0,0.04)" }}>
                  <span style={{ fontSize: "1.1rem", flexShrink: 0 }}>{item.icon}</span>
                  <span style={{ fontSize: "0.78rem", fontWeight: 600, color: "#1e293b", lineHeight: 1.4 }}>{item.label}</span>
                </div>
              ))}
            </div>

            {/* Body copy */}
            <p style={{ fontSize: "0.95rem", color: "#334155", lineHeight: 1.85, marginBottom: "40px", fontWeight: 500 }}>
              GBR Farming provides the deployment architecture and packaging model required to help agribusinesses evolve into ecosystem operators.
            </p>

            {/* CTA buttons */}
            <div style={{ display: "flex", gap: "14px", justifyContent: "center", flexWrap: "wrap" }}>
              <NavLink to="/si-registration" style={{ textDecoration: "none" }}>
                <div
                  style={{ background: "#15803d", borderRadius: "12px", padding: "14px 28px", fontSize: "0.88rem", fontWeight: 700, color: "#ffffff", cursor: "pointer", transition: "opacity 0.2s", letterSpacing: "0.2px", boxShadow: "0 4px 14px rgba(21,128,61,0.3)" }}
                  onMouseEnter={(e) => { e.currentTarget.style.opacity = "0.88"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.opacity = "1"; }}
                >
                  Discuss Deployment
                </div>
              </NavLink>
              {/* <NavLink to="/OurProductsAndService" style={{ textDecoration: "none" }}>
                <div
                  style={{ background: "#ffffff", border: "1.5px solid #cbd5e1", borderRadius: "12px", padding: "14px 28px", fontSize: "0.88rem", fontWeight: 700, color: "#334155", cursor: "pointer", transition: "border-color 0.2s, color 0.2s" }}
                  onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#15803d"; e.currentTarget.style.color = "#15803d"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#cbd5e1"; e.currentTarget.style.color = "#334155"; }}
                >
                  Explore Infrastructure
                </div>
              </NavLink> */}
            </div>

          </div>
        </Container>
      </div>

    </div>
  );
};

export default OurProductAndServices;
